<template>
	<div class="order-detail-container">
        <!-- 页面头部 -->
        <div class="page-header">
            <h1 class="page-title">预约单详情</h1>
            <p class="page-subtitle">预约单号：{{ orderList.apporder }}</p>
        </div>

        <!-- 详情卡片 -->
        <div class="detail-card">
            <!-- 基本信息 -->
            <div class="info-section">
                <h3 class="section-title">基本信息</h3>
                <div class="info-list">
                    <div class="info-item">
                        <span class="info-label">预定号码</span>
                        <span class="info-value">{{ orderList.apporder }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">订单日期</span>
                        <span class="info-value">{{ orderList.Appdate }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">预约人</span>
                        <span class="info-value">{{ orderList.Appname }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">预留电话</span>
                        <span class="info-value">{{ orderList.apptel }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">服务方式</span>
                        <span class="info-value">{{ orderList.ordtype }}</span>
                    </div>
                    <div class="info-item">
                        <span class="info-label">当前状态</span>
                        <van-tag :type="getStatusType(orderList.status)" class="status-tag">
                            {{ orderList.status }}
                        </van-tag>
                    </div>
                </div>
            </div>

            <!-- 地址信息 -->
            <div class="info-section">
                <h3 class="section-title">地址信息</h3>
                <div class="info-list">
                    <div class="info-item full-width">
                        <span class="info-label">上门地址</span>
                        <div class="long-text-content address-value">
                            {{ orderList.onsiteAddress }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 产品信息 -->
            <div class="info-section">
                <h3 class="section-title">产品信息</h3>
                <div class="info-list">
                    <div class="info-item">
                        <span class="info-label">产品SN</span>
                        <span class="info-value">{{ orderList.Serilcode }}</span>
                    </div>
                </div>
            </div>

            <!-- 问题描述 -->
            <div class="info-section">
                <h3 class="section-title">问题描述</h3>
                <div class="info-list">
                    <div class="info-item full-width">
                        <span class="info-label">故障现象</span>
                        <div class="long-text-content memo-value">
                            {{ orderList.memo1 }}
                        </div>
                    </div>
                    <div class="info-item full-width">
                        <span class="info-label">留言</span>
                        <div class="long-text-content memo-value">
                            {{ orderList.memo2 }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- 服务站信息 -->
            <div class="info-section">
                <h3 class="section-title">服务站信息</h3>
                <div class="info-list">
                    <div class="info-item">
                        <span class="info-label">服务站ID</span>
                        <span class="info-value">{{ orderList.staid }}</span>
                    </div>
                    <div class="info-item full-width">
                        <span class="info-label">服务站名称</span>
                        <span class="info-value">{{ orderList.Station }}</span>
                    </div>
                    <div class="info-item full-width">
                        <span class="info-label">服务站地址</span>
                        <div class="long-text-content address-value">
                            {{ orderList.Staaddress }}
                        </div>
                    </div>
                    <div class="info-item">
                        <span class="info-label">服务站电话</span>
                        <span class="info-value phone-value">{{ orderList.Asptel }}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- 返回按钮 -->
        <div class="action-section">
            <van-button type="primary" size="large" class="back-btn" to="/reserve">
                <van-icon name="arrow-left" class="btn-icon" />
                返回列表
            </van-button>
        </div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import {Dialog} from 'vant'	
	
	export default {
	  name: 'RODETAIL',	 
	  data(){
	  	return{	
			orderList:[],
			access_token:''
		}
	  },
	  created(){				
        var that = this;		
        that.getApporders(that.$root.common.curorderid);
      },		
	  mounted(){
		document.title="预约单详情"
	  },
	  methods:{
        getStatusType(status) {
            const statusMap = {
                '待处理': 'warning',
                '已确认': 'success',
                '进行中': 'primary',
                '已完成': 'success',
                '已取消': 'danger'
            }
            return statusMap[status] || 'default'
        },
		getApporders(orderid){
			var that = this;
			var myUrl = that.global.BASE_URL_T3 + '/api/pdsm/myapporders?apporderid=' + orderid;				
			var config = {
			  method: 'get',
			  url: myUrl,
			  headers: { 
				'Authorization': localStorage['access_token']		
			  }
			}				
			Vue.axios(config)
			.then(function (response) {
			  if (response.data.Status == 0)
			  {
				that.orderList = response.data.Data[0];
			  }		
			  console.log(that.orderList)
			})
			.catch(function (error) {
			  console.log(error);
			});
		}
	  }
	}
</script>

<style scoped>
.order-detail-container {
    background-color: #f7f8fa;
    min-height: 100vh;
    padding-bottom: 80px;
}

.page-header {
    background-color: #ffffff;
    padding: 20px 16px;
    text-align: center;
    border-bottom: 1px solid #f0f0f0;
}

.page-title {
    font-size: 18px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 4px;
}

.page-subtitle {
    font-size: 14px;
    color: #969799;
    margin: 0;
}

.detail-card {
    background-color: #ffffff;
    margin: 16px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    border: 1px solid #f0f0f0;
    overflow: hidden;
}

.info-section {
    padding: 20px;
    border-bottom: 1px solid #f5f5f5;
}

.info-section:last-child {
    border-bottom: none;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    color: #323233;
    margin-bottom: 16px;
    text-align: left;
    display: flex;
    align-items: center;
}

.section-title::before {
    content: '';
    width: 4px;
    height: 16px;
    background-color: #1989fa;
    border-radius: 2px;
    margin-right: 8px;
}

.info-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.info-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0;
}

.info-item.full-width {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
}

.info-label {
    font-size: 14px;
    color: #646566;
    font-weight: 500;
    min-width: 80px;
    flex-shrink: 0;
    text-align: left;
}

.info-value {
    font-size: 14px;
    color: #323233;
    font-weight: 500;
    text-align: left;
    flex: 1;
    margin-left: 16px;
    line-height: 1.4;
    word-break: break-all;
    overflow-wrap: break-word;
}

.info-item.full-width .info-value {
    text-align: left;
    margin-left: 0;
    width: 100%;
}

.long-text-content {
    width: 100%;
    background-color: #f8f9fa;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    padding: 12px;
    font-size: 14px;
    line-height: 1.5;
    word-break: break-all;
    overflow-wrap: break-word;
    box-sizing: border-box;
    text-align: left;
}

.address-value {
    background-color: #f8f9fa;
    border-color: #e8e8e8;
}

.memo-value {
    background-color: #f6ffed;
    border-color: #b7eb8f;
}

.phone-value {
    color: #1989fa;
    font-weight: bold;
}

.status-tag {
    margin: 0;
}

.action-section {
    padding: 16px;
    background-color: #ffffff;
    border-top: 1px solid #f0f0f0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
}

.back-btn {
    border-radius: 8px;
}

.btn-icon {
    margin-right: 4px;
}
</style>